import { RegisterModule } from '@/typings/common'
import {
  RoadmapDirection as Data,
  RoadmapDirectionCollection as Collection,
} from '@/typings/api/RoadmapDirection'
import { RoadmapDirectionsApi as Api } from '@/api/resources'

import { registerModule as vuexRegisterModule } from 'vuex-smart-module'
import { Builder } from '@/store/createCrudModule'
import {
  RoadmapDirectionsAdapter as Adapter,
} from './RoadmapDirectionsAdapter'
import { MODULE_NAME } from '../utils'


const useOptions = () => ({
  adapter: new Adapter(),
  idName: 'id' as const,
})

const storeModule = Builder<Data, Collection, Api>(useOptions)
export { storeModule as roadmapDirectionsStoreModule }

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
